// Luxury scroll animation for Philosophy section
document.addEventListener('DOMContentLoaded', function() {
  const philosophySection = document.querySelector('.ir-philosophy');
  
  if (!philosophySection) return;
  
  // Create intersection observer with luxury timing
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add animation class with slight delay for luxury feel
        setTimeout(() => {
          entry.target.classList.add('animate-in');
        }, 100);
        
        // Unobserve after animation starts to prevent re-triggering
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.2, // Trigger when 20% of section is visible
    rootMargin: '0px 0px -50px 0px' // Start animation slightly before fully visible
  });
  
  // Start observing the philosophy section
  observer.observe(philosophySection);
  
  // Add subtle parallax effect on scroll for extra luxury feel
  let ticking = false;
  
  function updateParallax() {
    const scrolled = window.pageYOffset;
    const sectionTop = philosophySection.offsetTop;
    const sectionHeight = philosophySection.offsetHeight;
    const windowHeight = window.innerHeight;
    
    // Only apply parallax when section is in viewport
    if (scrolled + windowHeight > sectionTop && scrolled < sectionTop + sectionHeight) {
      const rate = (scrolled - sectionTop + windowHeight) / (sectionHeight + windowHeight);
      const yPos = -(rate * 20); // Subtle 20px parallax movement
      
      philosophySection.style.transform = `translateY(${yPos}px)`;
    }
    
    ticking = false;
  }
  
  function requestParallaxUpdate() {
    if (!ticking) {
      requestAnimationFrame(updateParallax);
      ticking = true;
    }
  }
  
  // Add scroll listener for parallax effect
  window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
});
